import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AccountFilterComponent, DateFilterComponent } from "../../_shared/components";
import { BasePageComponent } from '../../_shared/components/page/base-page.component';
import { AccountFilterData, DateIntervalFilterData, WidgetFilterData } from '../../_shared/models';
import { DateInterval } from '../../_shared/enums';
import { isEmptyObject } from '../../_shared/helpers/helpers';
import { FilterService } from '../../_shared/services';
import { MaintenanceRequiredWidgetComponent } from "./components/widgets/maintenance-required-widget/maintenance-required-widget.component";
import { TotalMaintenanceCostWidgetComponent } from "./components/widgets/total-maintenance-cost-widget/total-maintenance-cost-widget.component";
import { AvailableAssetsWidgetComponent } from "./components/widgets/available-assets-widget/available-assets-widget.component";
import { AvgWorkshopDowntimeWidgetComponent } from "./components/widgets/avg-workshop-downtime-widget/avg-workshop-downtime-widget.component";
import { UpcomingActivityWidgetComponent } from "./components/widgets/upcoming-activity-widget/upcoming-activity-widget.component";
import { WorkOrdersTrendComponent } from './components/graphs/work-orders-trend/work-orders-trend.component';
import { MaintenanceCostTrendComponent } from './components/graphs/maintenance-cost-trend/maintenance-cost-trend.component';
import { PartsInventoryTrendComponent } from './components/graphs/parts-inventory-trend/parts-inventory-trend.component';
import { ComplianceTrendComponent } from './components/graphs/compliance-trend/compliance-trend.component';
import { getSelectedFilterLabel } from '../../_shared/helpers/kpiWidget/selected-filter.helper';
import { AssetType } from '../_shared/enums/asset-type.enum';
import { ALL_ASSET_TYPES } from '../_shared/helpers/asset-type-filter.helper';
import { AssetTypeFilterComponent } from '../../_shared/components/filters/asset-type-filter/asset-type-filter.component';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'app-dashboard',
  standalone: true,
  imports: [
    TranslocoPipe,
    CommonModule,
    AccountFilterComponent,
    DateFilterComponent,
    AssetTypeFilterComponent,
    MaintenanceRequiredWidgetComponent,
    TotalMaintenanceCostWidgetComponent,
    AvailableAssetsWidgetComponent,
    AvgWorkshopDowntimeWidgetComponent,
    WorkOrdersTrendComponent,
    MaintenanceCostTrendComponent,
    PartsInventoryTrendComponent,
    ComplianceTrendComponent,
    UpcomingActivityWidgetComponent
  ],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.scss'
})
export class DashboardComponent extends BasePageComponent {
  private readonly transloco = inject(TranslocoService);
  accountFilter: AccountFilterData;
  dateFilter: DateIntervalFilterData;

  defaultInterval: DateInterval = DateInterval.Month;
  disabledIntervals: DateInterval[] = [DateInterval.Half];

  private filterService: FilterService = inject(FilterService);

  assetType: AssetType[] = [...ALL_ASSET_TYPES];

  constructor() {
    super();
    this.accountFilter = {} as AccountFilterData;
    this.dateFilter = {} as DateIntervalFilterData;
  }

  onAssetTypeFilter(assetType: AssetType | null): void {
    this.assetType = assetType === null ? [...ALL_ASSET_TYPES] : [assetType];
  }

  protected override onRefresh(): void { }

  protected override shouldRefresh(): boolean { return false; }

  protected override getFilters() {
    return {
      ...this.dateFilter,
      ...this.accountFilter
    }
  }

  protected override applyPageFilterState(pageFilter: any): void { }

  getSelectedFilterLabel(): string {
    return getSelectedFilterLabel(this.dateFilter, (key, params) => this.transloco.translate(key, params), this.transloco.getActiveLang());
  }

  onDateFilterChange(filter: DateIntervalFilterData): void {
    this.dateFilter = filter;
    this.updateFilter();
  }
  onAccountFilterChange(filter: AccountFilterData): void {
    this.accountFilter = filter;
    this.updateFilter();
  }

  private updateFilter(): void {
    if (!isEmptyObject(this.dateFilter) && !isEmptyObject(this.accountFilter)) {
      this.filterService.updateFilter({
        ...this.dateFilter,
        ...this.accountFilter
      } as WidgetFilterData);

      this.updatePageFilterState();
    }
  }
}
